import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var GlassIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 14 14" }),
    React.createElement("path", { d: "M0.4 0.4H13.6V12C13.6 12.8837 12.8837 13.6 12 13.6H2C1.11634 13.6 0.4 12.8837 0.4 12V0.4Z", stroke: "currentColor", strokeWidth: "0.8", fill: "none" }),
    React.createElement("line", { y1: "7.6", x2: "14", y2: "7.6", stroke: "currentColor", strokeWidth: "0.8" }),
    React.createElement("rect", { x: "0.4", y: "12.4", width: "13.2", height: "1.2", rx: "0.6", fill: "none", stroke: "currentColor", strokeWidth: "0.8" }))); };

export default GlassIcon;
